<template>
  <carousel :items="1" :autoplay="false" :nav="false">
    <img v-for="slide in slides" :key="slide" :src="slide" />
  </carousel>
</template>


  <script>
import carousel from "vue-owl-carousel";

export default {
  components: { carousel },
  props: {
    slides: {
      type: Array,
      required: true,
      default: [],
    },
  },

  mounted() {

  },
};
</script>
